import { Component, OnInit } from '@angular/core';
import {
  AcabimProject,
  ColumnFilter,
  DataTableColumnData,
  DataTableConfig, DataTableDataSource,
  DataTableLazyLoadDataSource,
  DataTableLazyLoadRefresher,
  DataTableObservableCompletionListener,
  DataTableObservableErrorListener, PaginatedRequest, PaginatedResponse, ProjectApiService, Status,
  TableAction
} from '@cas-hub/acabim-common-client';
import {map, tap} from 'rxjs/operators';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'acabim-admin-dashboard-projects',
  templateUrl: './dashboard-projects.component.html',
  styleUrls: ['./dashboard-projects.component.scss']
})
export class DashboardProjectsComponent implements OnInit {
  public projectDataSources: DataTableDataSource<AcabimProject>[] = [];

  constructor(private readonly projectAPIService: ProjectApiService, protected readonly datePipe: DatePipe) { }

  ngOnInit(): void {
    this.projectDataSources.push(
        // @ts-ignore
        new ProjectDataSource((first, length, sortOrder, sortField, filters) => {
              if (!sortField) {
                sortField = 'site';
                sortOrder = 0;
              }
              const paginatedRequest = PaginatedRequest.FromDatatableRefresher(first, length, sortOrder, sortField);
              const queryParams = ProjectApiService.createProjectQueryOptionsFromFilters(filters) ?? {};
              queryParams.filterStatus = Status.active;
              queryParams.includeSite = true;
              queryParams.includeBuildingStatus = true;

              return this.projectAPIService.getAllProjects(paginatedRequest, queryParams)
                  .pipe(map(data => data as PaginatedResponse<AcabimProject>), map(data => ({
                    totalRecords: data.totalRecords,
                    data: data.data
                  })), tap(data => {
                    data.data.forEach(project => {
                      project.lastModifiedDate = this.getDate(project.lastModifiedDate);
                    });
                  }));
            },
            (tableName: string, error: Error) => {
            },
            (tableName: string) => {
              console.log('completion');
            }, (action: TableAction) => {
            }
        )
    );
  }
  getDate(date: string): string {
    const newDate = new Date(date);
    return (this.datePipe.transform(newDate, 'dd MMM yyyy') as string);
  }

    toggleBuildingDetailStatus($event: boolean) {
        this.projectDataSources[0].showDetails = $event;
    }
}


export class ProjectDataSource extends DataTableLazyLoadDataSource<AcabimProject> {


  readonly columnData: DataTableColumnData[] =
      [
        {displayName: 'Name', objectPropertyName: 'name'},
        {displayName: 'Site Name', objectPropertyName: 'site.name'},
        {displayName: 'Project Phase', objectPropertyName: 'currentPhase'},
        {displayName: 'BIM Status', objectPropertyName: 'buildingStatus'},
        {displayName: 'Last Modified', objectPropertyName: 'lastModifiedDate'}
      ];
  readonly config: DataTableConfig = {
    tableHeading: '',
    isSearchEnabled: true,
    searchPlaceHolder: 'Search WorkOrder',
    emptyMessage: '',
    globalFilterFields: [],
    hasCheckbox: false,
    hasDetailsButton: true,
    isLazyLoadingEnabled: true,
    isPaginationEnabled: true,
    hasFilters: true,
    isExportEnabled: false,
    hasActions: true
  };
  readonly columnFilters: ColumnFilter[] = [];
  readonly actions: TableAction[] = [];

  onDataExpanded(value: AcabimProject): void {
  }

  constructor(readonly refresher: DataTableLazyLoadRefresher<AcabimProject>,
              readonly observableErrorListener?: DataTableObservableErrorListener,
              readonly observableCompleteListener?: DataTableObservableCompletionListener,
              readonly actionListener?: (action: TableAction) => void) {
    super(refresher, observableErrorListener, observableCompleteListener);
  }

  onAction(action: TableAction): void {
    if (this.actionListener) {
      this.actionListener(action);
    }
  }

}
